<template>
  <div class="container">
    <div class="row mt-3">
      <div class="col-5">
        <h5>Cabecera</h5>
        <div>
          <input placeholder="id" v-model.number="modelo[0].id" class="form-control w-50 mb-1" type="text">
          <input placeholder="anio" v-model.number="modelo[0].anio" class="form-control w-50 mb-1" type="text">
          <input placeholder="titulo" v-model.trim="modelo[0].titulo" class="form-control w-50 mb-1" type="text">
          <input placeholder="descripcion" v-model.trim="modelo[0].descripcion" class="form-control w-50 mb-1" type="text">
          <input placeholder="encabezado1" v-model.trim="modelo[0].encabezado1" class="form-control w-50 mb-1" type="text">
          <input placeholder="encabezado2" v-model.trim="modelo[0].encabezado2" class="form-control w-50 mb-1" type="text">
          <input placeholder="encabezado3" v-model.trim="modelo[0].encabezado3" class="form-control w-50 mb-1" type="text">
          <input placeholder="encabezado4" v-model.trim="modelo[0].encabezado4" class="form-control w-50 mb-1" type="text">
          <input placeholder="propietario_documento" v-model="modelo[0].propietario_documento" class="form-control w-50 mb-1" type="text">
          <input placeholder="fecha_actualizacion" v-model="modelo[0].fecha_actualizacion" class="form-control w-50 mb-1" type="text">
        </div>

        <div class="mt-7">
          <h5>Contenido</h5>
          <input placeholder="Contenido" v-model.number="contenidoList.idContenido" class="form-control w-50 mb-1" type="text">
          <input placeholder="titulo" v-model.trim="contenidoList.titulo" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_pdf1" v-model.trim="contenidoList.url_pdf1" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_pdf2" v-model.trim="contenidoList.url_pdf2" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_pdf3" v-model.trim="contenidoList.url_pdf3" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_pdf4" v-model.trim="contenidoList.url_pdf4" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_comprimido" v-model.trim="contenidoList.url_comprimido" class="form-control w-50 mb-1" type="text">
          <button @click="armarElemento()" type="button" class="btn btn-success btn-largo">push</button>
          <button type="button" class="btn btn-secondary btn-largo mt-5" data-toggle="modal" data-target="#staticBackdrop">Borrar todo</button>
        </div>
      </div>
      <div class="col-6 toScroll">
        <pre class="text-danger">{{ modelo }}</pre>
      </div>
    </div>

    <!-- modal de confirmacion borrado -->
    <!-- Modal -->
    <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-danger d-flex justify-content-center">
          <h5 class="modal-title text-white text-center" id="staticBackdropLabel">¿Segura que quieres borrar?</h5>
          <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button> -->
        </div>
        <!-- <div class="modal-body">
          ...
        </div> -->
        <div class="modal-footer d-flex justify-content-center">
          <button @click="reset()" type="button" class="btn btn-danger px-5" data-dismiss="modal">Si, Eliminar</button>
          <button type="button" class="btn btn-secondary px-5" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
    </div>


  </div>
</template>
<script>
export default {
    name: 'correccion',
    mounted(){
      this.contenidoList.idContenido = 1;
    },
    data() {
        return {
          contador: 1,
          modelo: [
            {
              "id": 0,
              "anio": 0,
              "titulo": "",
              "descripcion":"",
              "encabezado1": "",
              "encabezado2": "",
              "encabezado3": "",
              "encabezado4": "",
              "propietario_documento": "",
              "fecha_actualizacion": "2024-09-20",
              "contenido": []
            }
          ],
          contenidoList: {
            "idContenido": 0,
            "titulo": "",
            "url_pdf1": "",
            "url_pdf2": "",
            "url_pdf3": "",
            "url_pdf4": "",
            "url_comprimido": ""
          }
        };
    },
    methods: {
      armarElemento(){
        this.modelo[0].contenido.push(this.contenidoList);
        this.contenidoList = {
            "idContenido": this.contador+1,
            "titulo": "",
            "url_pdf1": "",
            "url_pdf2": "",
            "url_pdf3": "",
            "url_pdf4": "",
            "url_comprimido": ""
          }
          this.contador +=1;
      },
      removeElemento(){

      },
      editElemento(){

      },
      reset(){
        this.modelo = [
            {
              "id": 0,
              "anio": 0,
              "titulo": "",
              "descripcion":"",
              "encabezado1": "",
              "encabezado2": "",
              "encabezado3": "",
              "encabezado4": "",
              "propietario_documento": "",
              "fecha_actualizacion": "2024-09-20",
              "contenido": []
            }
          ],
          this.contenidoList = {
            "idContenido": 1,
            "titulo": "",
            "url_pdf1": "",
            "url_pdf2": "",
            "url_pdf3": "",
            "url_pdf4": "",
            "url_comprimido": ""
          }
          this.contador = 1;
      }
    }
}



</script>
<style scoped>
.form-control {height: 1.4rem !important;}
.btn-largo{
  padding-left: 30px !important;
  padding-right: 30px !important;
  display: block;
  margin-top: .5rem;
}
.toScroll {
  height:100vh;
  overflow-y: scroll;
}
</style>
